/* global $ */
/* eslint no-unused-vars: 0 */

import { syncHeight } from '../helpers/dom-tools';

const $html = $('html');
const $menuOverlay = $.$body.find('.menuOverlay');
let timeOutTimer = null;

// Set tracked last scroll.
let lastScrollPosition = 0;

/**
 * Sync height to help with modal scroll locking.
 */
window.addEventListener('resize', syncHeight);

/**
 * Named func for preventing scrolling event.
 * Must be named to allow unbinding.
 *
 * @param {Object} e A jquery event.
 */
const preventDefaultNamed = (e) => {
	e.preventDefault();
};

/**
 * Handle locking scroll.
 * Uses global lastScrollPosition.
 *
 * @param {boolean} opening If opening or closing.
 * @param {Object} $menu The menu element, jQuery object.
 */
const handleScrollLock = (opening, $menu) => {
	if (opening === true) {
		// Lock scroll.
		$menu.on('pointermove', preventDefaultNamed);
		$('html').css({
			height: 'calc(var(--window-sync-height) - 1px)',
		});
		$.$body.css({
			position: 'fixed',
			overflowY: 'hidden',
			top: `-${lastScrollPosition}px`,
		});
	} else {
		// Relase scroll lock.
		$menu.off('pointermove', preventDefaultNamed);
		$('html').css({
			height: '100%',
		});
		$.$body.css({
			position: '',
			overflowY: 'unset',
			top: '',
		});
		// Use 'instant' to prevent scroll jump.
		window.scrollTo({
			top: lastScrollPosition,
			left: 0,
			behavior: 'instant',
		});
	}
};

/**
 * Handle opening menu.
 *
 * @param {Object} e The jquery event object.
 */
const openMenu = (e) => {
	e.preventDefault();
	clearTimeout(timeOutTimer);

	lastScrollPosition = $('html, body').scrollTop();

	$menuOverlay
		.addClass('menu-pre--open temp-high-z')
		.prop('hidden', false);

	timeOutTimer = setTimeout(() => {
		$menuOverlay.addClass('menu--open');
		$html.addClass('overlay-active mobile-menu-active');
		$menuOverlay.find('.mobile-overlay__inner').scrollTop(0);
		$menuOverlay.attr('aria-hidden', false);
	}, 2);

	// Lock scroll.
	handleScrollLock(true, $menuOverlay);
};

/**
 * Handle closing menu.
 *
 * @param {Object} e The event object.
 * @param {boolean} cancelEvent Event cancel.
 */
const closeMenu = (e, cancelEvent) => {
	e.preventDefault();
	clearTimeout(timeOutTimer);

	if (cancelEvent && e) {
		e.preventDefault();
		e.stopPropagation();
	}

	// Realse scroll.
	handleScrollLock(false, $menuOverlay);

	$html.removeClass('overlay-active mobile-menu-active');
	$menuOverlay.removeClass('menu--open');

	// Helps prevent flicker on IOS.
	setTimeout(() => {
		$menuOverlay
			.removeClass('temp-high-z menu--pre-open')
			.prop('hidden', true);
	}, 200);
};

$.$body
	.on('click', '#btn-menu:not(.is-active)', openMenu)
	.on(
		'click',
		'#btn-menu-close, #btn-menu.is-active',
		closeMenu
	);

// Close on ESC.
document.addEventListener('keydown', (e) => {
	if (e.key === 'Escape' && $menuOverlay.hasClass('menu--open')) {
		closeMenu(e);
	}
});